import { apiSlice } from 'state/slices/apiSlice';

const HOLIDAYS_URL = '/holidays';

export const holidayApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createHoliday: builder.mutation({
      query: (holidayData) => ({
        url: `${HOLIDAYS_URL}/create`,
        method: 'POST',
        body: holidayData,
        transformResponse: (response) => response.json(),
      }),
    }),
    getUpcomingHoliday: builder.query({
      query: () => `${HOLIDAYS_URL}/upcoming`,
      extraOptions: { skipToastOn: [404] },
    }),
    getHolidays: builder.query({
      query: () => `${HOLIDAYS_URL}/list`,
    }),
    updateHoliday: builder.mutation({
      query: (data) => {
        return {
          url: `${HOLIDAYS_URL}/update`,
          method: 'PUT',
          body: { ...data },
        };
      },
    }),
    deleteHoliday: builder.mutation({
      query: (id) => ({
        url: `${HOLIDAYS_URL}/delete`,
        method: 'DELETE',
        body: { id }
      }),
    }),
  }),
});

export const {
  useCreateHolidayMutation,
  useGetUpcomingHolidayQuery,
  useGetHolidaysQuery,
  useUpdateHolidayMutation,
  useDeleteHolidayMutation,
} = holidayApiSlice;
